import * as Config from '../../../../../../config';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import DragItem from '../../../../dnd/DragItem';
import ColumnChecker from '../../ColumnChecker';
import ColumnActions from '../../ColumnActions';
import ColumnUpgrade from '../../ColumnUpgrade';
import ColumnCover from '../../ColumnCover';
import ColumnTrack from '../../ColumnTrack';
import ColumnLabel from '../../ColumnLabel';
import ColumnGenre from '../../ColumnGenre';
import ColumnBpmKey from '../../ColumnBpmKey';
import ColumnMore from '../../ColumnMore';
import ColumnDate from '../../ColumnDate';
import ColumnTime from '../../ColumnTime';
import ColumnRemixer from '../../ColumnRemixer';
import ColumnRowActions from '../../ColumnRowActions';

import useTrackAccess from '../../hooks/useTrackAccess';

// React.memo(
const ConnectedRowFullPlus = ({
  idParent, item, index, width, height, className = 'item', style, onClick,
  end,
  isTablet
}) => {

  const {
    isEnabled, isDisabled,
    playerLoadSong,
    previewPlayer, isPreview, stylePreview,
    beginDnD, showContextMenu, 
    addToCart, isInCart,
    addToPlaylist
  } = useTrackAccess(item, idParent, index);

  const onClickRow = (e) => onClick(item, e, index);

  const RSizeChecker = 0; //10;
  const RSizeNumber = 30;
  const RSizeActions = isTablet ? 90 : 50;
  const RSizeCover = 48;
  const RSizeMore = 30;
  const RSizeExtra = 45;
  const RSizeKey = 90;
  const RSizeRelease = 95;
  const RSizeTime = 50;

  const RTotal = RSizeChecker + RSizeNumber + RSizeActions + RSizeCover + RSizeMore + RSizeKey + RSizeRelease + RSizeTime + RSizeExtra;
  let RSizeTrack = ((width - RTotal) * 33 / 100);
  let RSizeRemixer = ((width - RTotal) * 20 / 100);
  let RSizeLabel = ((width - RTotal) * 25 / 100);
  let RSizeGenre = ((width - RTotal) * 22 / 100);
  RSizeTrack += (Config.LIST_HEADER_HAS_REMIXER) ? 0 : RSizeRemixer;

  return (
    <>
      <DragItem type={isEnabled ? `TRACK` : `X`} idParent={idParent} begin={beginDnD} end={end} onClick={onClickRow} item={item} className={`${isPreview && `preview`} ${(previewPlayer && !previewPlayer.isPlaying) && 'off'} ${className} ${(isDisabled) && `disabled`} `} style={stylePreview({ width, height })}>
        <ColumnChecker width={RSizeNumber} isDisabled={isDisabled} trackID={item.id} value={item.top} />
        <ColumnActions width={RSizeActions} keyID={item.id} isPreview={(!previewPlayer.isPlaying || !isPreview)} isTablet={isTablet}
            onClickPlayDeckA={playerLoadSong(1)} onClickPlayDeckB={playerLoadSong(2)}
            onPreviewBackward={previewPlayer.backward} onPreviewForward={previewPlayer.forward} />
        <ColumnCover width={RSizeCover} item={item} previewPlayer={previewPlayer} />
        <ColumnTrack width={RSizeTrack} item={item} includeRemixers={false} containerStyle={{ marginRight: 10 }}  />
        { (Config.LIST_HEADER_HAS_REMIXER) && (
          <ColumnRemixer width={RSizeRemixer} remixers={item.remixers} />
        )}
        <ColumnLabel width={RSizeLabel - 8} item={item} style={{ marginRight: 8 }}  />
        <ColumnGenre width={RSizeGenre} item={item}  />
        <ColumnBpmKey width={RSizeKey} item={item} />
        { isEnabled ? (
          <>
            <ColumnDate width={RSizeRelease} date={item.release} />
            <ColumnTime width={RSizeTime} duration={item.length} durationMs={item.length_ms} />
            <ColumnRowActions width={RSizeExtra} onClickCart={addToCart} isInCart={isInCart} onClickPlaylist={addToPlaylist} />
            <ColumnMore width={RSizeMore} id={item.id} onClick={showContextMenu} />
          </>
        ) : (
          <ColumnUpgrade width={RSizeRelease + RSizeTime + RSizeMore + RSizeExtra} />
        )}
      </DragItem>
    </>
  )

};

ConnectedRowFullPlus.propTypes = {
  item: PropTypes.object.isRequired,
  idParent: PropTypes.any,
  index: PropTypes.number.isRequired,
  width: PropTypes.any.isRequired,
  height: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  end: PropTypes.func
}

const RowFullPlus = connect(
  state => ({
    isTablet: state.layoutTablet
  })
)(ConnectedRowFullPlus);

export default RowFullPlus;
